import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = ["type"]
const _hoisted_2 = {
  key: 0,
  class: "absolute w-full h-full top-0 left-0 rounded-full bg-nucleus-error text-white flex justify-center items-center"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("button", {
    type: _ctx.type,
    class: _normalizeClass(["block relative bg-nucleus-error hover:bg-nucleus-errorHover p-3 text-white text-lg text-center shadow-md rounded-full transition w-full disabled:opacity-50 disabled:cursor-not-allowed disabled:hover:bg-nucleus-primaryBlue", _ctx.ifLoading()])
  }, [
    (_ctx.loading)
      ? (_openBlock(), _createElementBlock("span", _hoisted_2, _cache[0] || (_cache[0] = [
          _createElementVNode("span", { class: "loader ease-linear rounded-full border-2 border-t-2 border-nucleus-errorHover h-6 w-6 animate-spin" }, null, -1)
        ])))
      : _createCommentVNode("", true),
    _createTextVNode(" " + _toDisplayString(_ctx.name), 1)
  ], 10, _hoisted_1))
}